import axios from '@/libs/api.request'

/**
 * 获取活动列表
 * @returns {wx.RequestTask | never}
 */
export const getActivityList = (params) => {
  return axios.request({
    url: 'main/activity/getList',
    method: 'get',
    params: params
  })
}

/**
 * 展会论坛 发布/编辑
 * @returns {wx.RequestTask | never}
 */
export const releaseActivity = (data) => {
  return axios.request({
    url: 'main/activity/save',
    method: 'post',
    data
  })
}

/**
 * 删除
 * @returns {wx.RequestTask | never}
 */
export const deleteActivity = (data) => {
  return axios.request({
    url: 'main/activity/delete',
    method: 'post',
    data
  })
}
/**
 * 获取报名记录
 * @returns {wx.RequestTask | never}
 */
export const getActivityRegisterRecord = (params) => {
  return axios.request({
    url: 'main/activity/getRegisterRecord',
    method: 'get',
    params
  })
}

/**
 * 导出报名记录
 * @returns {wx.RequestTask | never}
 */
export const exportRegisterRecord = (params) => {
  return axios.request({
    url: 'main/activity/exportRegisterRecord',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
/**
 * 获取订单详情信息
 * @returns {wx.RequestTask | never}
 */
export const getMemberOrderDetail = (params) => {
  return axios.request({
    url: 'main/order/getDetail',
    method: 'get',
    params
  })
}
/**
 * 上传图片
 * @returns {wx.RequestTask | never}
 */
export const uploadPic = (data) => {
  return axios.request({
    url: 'main/upload',
    method: 'post',
    data
  })
}
/**
 * 获取小程序码
 * @returns {wx.RequestTask | never}
 */
export const getXcxCode = (params) => {
  return axios.request({
    url: 'main/activity/getXcxCode',
    method: 'get',
    params
  })
}
